<template>
    <div v-if="props.activeNo == 0">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="4" class="table-data">{{ $t('common.level') }}</van-col>
                <van-col span="4" class="table-data">{{ $t('vip.bets') }}</van-col>
                <van-col span="4" class="table-data">{{ $t('vip.upgradeBonus') }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isDailyReward === 1">{{ $t('vip.dailyBonus')
                    }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{ $t('vip.weeklyBonus')
                    }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{ $t('vip.monthlyBonus')
                    }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between">
                <van-col span="4" class="table-data" style="color: #ffb57fa6;">{{ $t('vip.title') }}
                    {{ item.level }}</van-col>
                <van-col span="4" class="table-data">{{ item.bet_min }}</van-col>
                <van-col span="4" class="table-data">{{ item.upgrade_bonus ? item.upgrade_bonus : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isDailyReward === 1">{{ item.daily_reward ?
                    item.daily_reward : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{ item.week_reward ?
                    item.week_reward : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{ item.month_reward ?
                    item.month_reward : '--'
                    }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-else-if="props.activeNo == 1">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="4" class="table-data">{{ $t('common.level') }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isDailyReward === 1">{{ $t('vip.dailyBonus')
                    }}</van-col>
                <van-col span="8" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{ $t('vip.weeklyBonus')
                    }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{ $t('vip.monthlyBonus')
                    }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between">
                <van-col span="4" class="table-data" style="color: #ffb57fa6;">{{ $t('vip.title') }}
                    {{ item.level }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isDailyReward === 1">{{
                    item.daily_reward_retention }}</van-col>
                <van-col span="8" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{
                    item.week_reward_retention }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{
                    item.month_reward_retention }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
import NoData from '../../components/common/noData.vue';

const props = defineProps({
    activeNo: {
        type: Number,
        required: true
    },
    tableData: {
        type: Array as () => any,
        required: false
    },
    activeData: {
        type: Object
    }
})
</script>
<style scoped>
.table-row {
    padding: 10px 0;
    font-size: 14px;
    background: #ffffff0a;
    margin-bottom: 2px;
}

.table-data {
    align-items: center;
    text-align: center;
    color: #ffffff73;
    font-size: 11px;
    font-weight: 100;
    padding: 0px 5px;
}

.table-container {
    background: transparent;
    border-radius: 12px;
    /* max-width: 400px; */
    font-family: sans-serif;
    color: white;
    margin-top: 20px;
}

.table-header {
    font-size: 10px;
    padding: 5px 0px;
    background: hsla(0, 0%, 100%, .15);
    border-radius: 10px 10px 0px 0px;
}

@media (min-width: 450px) {
    .table-data {
        font-size: 13px;
    }
}
</style>